module.exports = __webpack_public_path__ + "img/我能享受哪些政策.e663027a.png";